import React from "react";

import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <small>
        Coded by Elise Raney
        <br />
        <a
          rel="noreferrer"
          href="https://github.com/eliseraney/weather-app"
          target="_blank"
        >
          GitHub Repository
        </a>
      </small>
    </div>
  );
}
